export const TestIds = {
  itemLabel: 'submenu-item-label',
  subItemLabel: 'submenu-sub-item-label',
  rootLevelListItem: 'submenu-root-level-list-item',
};

export const DataHooks = {
  submenu: 'submenu',
} as const;

export const INNER_FOCUS_RING_CLASSNAME = 'has-inner-focus-ring';
